import React from "react";
import { TbBrandReactNative } from "react-icons/tb";
import { SiFlutter, SiFirebase, SiKotlin } from "react-icons/si";
import { FaApple, FaAws } from "react-icons/fa";

const TechnologiesSection = () => {

    const techs = [
        {
            icon: <TbBrandReactNative />,
            title: "React Native",
            desc: "Cross-platform mobile apps with native performance & smooth UI."
        },
        {
            icon: <SiFlutter />,
            title: "Flutter",
            desc: "Beautiful high-performance apps for iOS & Android from one codebase."
        },
        {
            icon: <FaApple />,
            title: "Swift",
            desc: "Premium native iOS applications crafted for Apple ecosystem."
        },
        {
            icon: <SiKotlin />,
            title: "Kotlin",
            desc: "Modern Android apps optimized for speed, scalability & UX."
        },
        {
            icon: <SiFirebase />,
            title: "Firebase",
            desc: "Real-time backend, push notifications & app infrastructure."
        },
        {
            icon: <FaAws />,
            title: "AWS",
            desc: "Scalable cloud architecture powering secure mobile platforms."
        },
    ];

    return (
        <>
            <section className="tech-section">

                {/* Background Effects */}
                <div className="tech-bg-grid"></div>
                <div className="tech-glow tech-glow-1"></div>
                <div className="tech-glow tech-glow-2"></div>

                <div className="tech-container">

                    {/* Heading */}
                    <div className="tech-heading">

                        <span className="tech-badge">

                            Technologies We Use
                        </span>

                        <h2 style={{ textAlign: "center" }}>
                            Modern Tech Stack For<br />
                            <span> Next-Gen Mobile Apps.</span>
                        </h2>

                        <p style={{ textAlign: "center" }}>
                            We build high-performance mobile applications
                            using cutting-edge technologies for iOS,
                            Android & cross-platform development.
                        </p>

                    </div>

                    {/* Orbit */}
                    <div className="tech-orbit-wrapper">

                        <div className="center-core">
                            <div className="core-ring"></div>
                            <div className="core-logo">
                                APP
                            </div>
                        </div>

                        {/* Orbit Rings */}
                        <div className="orbit orbit-1"></div>
                        <div className="orbit orbit-2"></div>

                        {/* Floating Tech Cards */}
                        <div className="tech-grid">

                            {techs.map((item, index) => (
                                <div
                                    className={`tech-card tech-card-${index + 1}`}
                                    key={index}
                                >

                                    <div className="tech-card-glow"></div>

                                    <div className="tech-icon">
                                        {item.icon}
                                    </div>

                                    <h3>{item.title}</h3>

                                    <p>{item.desc}</p>

                                    <div className="tech-line"></div>

                                </div>
                            ))}

                        </div>

                    </div>

                    {/* Bottom Stats */}
                    {/* <div className="tech-stats">

                    <div className="tech-stat-card">
                        <h3>50+</h3>
                        <span>Apps Delivered</span>
                    </div>

                    <div className="tech-stat-card">
                        <h3>99%</h3>
                        <span>Client Satisfaction</span>
                    </div>

                    <div className="tech-stat-card">
                        <h3>10M+</h3>
                        <span>App Downloads</span>
                    </div>

                    <div className="tech-stat-card">
                        <h3>24/7</h3>
                        <span>Support & Scaling</span>
                    </div>

                </div> */}

                </div>
                <style>{`.tech-icon{
    width:70px;
    height:70px;
    border-radius:20px;

    display:flex;
    align-items:center;
    justify-content:center;

    font-size:34px;
    color:#fff;

    background:linear-gradient(
        135deg,
        #E8212A,
        #ff646b
    );

    box-shadow:
        0 15px 35px rgba(232,33,42,.25);

    margin-bottom:20px;

    transition:.4s ease;
}

.tech-card:hover .tech-icon{
    transform:
        translateY(-8px)
        rotate(-6deg);

    box-shadow:
        0 25px 50px rgba(232,33,42,.35);
}`}</style>
            </section>
        </>
    );
};

export default TechnologiesSection;